export const getters = {
  getEOI: (state) => {
    return state;
  },
  getEOIId: (state) => {
    return state.ua_icexpressionofinterestid;
  },
  getEOISubmitted: (state) => {
    return state.ua_submiteoi;
  },
  getEOIStatus: (state) => {
    return state.ua_currentstatus;
  },
  getEOICurrentStep: (state) => {
    return state.ua_currentpageinapplication;
  },
  getReadyForFunding: (state) => {
    return state.ua_readyforfunding;
  },
  getCompanyName: (state) => {
    return state.ua_companyname;
  },
  getUnlockDocumentUpload: (state) => {
    return state.ua_unlockdocumentupload;
  },
  getSharepointFolderName: (state) => {
    return state.ua_sharepointfoldername;
  },
  getApplicationTypes: (state) => {
    return {
      small: state.ua_readyforfunding,
      large: state.ua_readyforfundinglarge
    };
  }
};
